var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"font-weight-bold",attrs:{"cols":"4"}},[_vm._v(" "+_vm._s(_vm.title)+": ")]),_c('v-col',{attrs:{"cols":"8"}},[_vm._v(" "+_vm._s(_vm.val)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }